'use client';

import { cn } from '@/libs';

type LuckyBallProps = {
  number: string;
  superNumber?: string;
  highlight?: boolean;
  disabled?: boolean;
  width?: string;
  height?: string;
  numberSize?: string;
};

export const LuckyBall = ({
  number,
  superNumber,
  highlight = false,
  disabled = false,
  width = 'w-7 md:w-9',
  height = 'h-7 md:h-9',
  numberSize = 'text-sm md:text-lg',
}: LuckyBallProps) => (
  <div
    className={cn(
      'relative flex items-center justify-center rounded-full font-bold text-foreground',
      width,
      height,
      numberSize,
      {
        'bg-primary text-primary-foreground': highlight && !disabled,
        'bg-foreground/10 text-foreground/60': disabled,
        'bg-background/60 border border-foreground/20': !highlight && !disabled,
      },
    )}
  >
    <span className="text-sm">{number}</span>
    {superNumber && (
      <div className="absolute -top-1 -right-1 w-4 h-4 border bg-background text-foreground rounded-full flex items-center justify-center text-2xs font-medium">
        {superNumber}
      </div>
    )}
  </div>
);
